import styled from 'styled-components';
import { EmptyState } from './empty-state';
import { Caption01, Text02 } from '../../styles';

export const CardEmptyState = styled(EmptyState)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  ${EmptyState.Message} {
    ${Caption01};
    ${Text02};
  }
`;
